// extracted by mini-css-extract-plugin
export default {"toolbar":"UniverseInfo_toolbar__OUkvk","containerBar":"UniverseInfo_containerBar__RsEom"};